import capitalize from '../helpers/capitalize'

const defaultMetaTitleKey = 'default-meta-title'
const defaultMetaDescriptionKey = 'default-meta-description'

export default {
  methods: {
    setMetaTitleMixin(title) {
      title = title || this.$tMeta(defaultMetaTitleKey)

      if(title === defaultMetaTitleKey) {
        title = 'Jobian'
      }

      const tag = getMetaTitle()
      tag.textContent = title
    },
    setMetaDescriptionMixin(content) {
      content = content || this.$tMeta(defaultMetaDescriptionKey)

      if(content === defaultMetaDescriptionKey) {
        content = 'Jobian'
      }
      const tag = getMetaDescription()
      tag.setAttribute('content', content)
    },
    setMetaKeywords(content) {
      if(content) {
        const tag = getMetaKeywords()
        tag.setAttribute('content', content)
      } else {
        deleteMetaKeywords()
      }
    },
    deleteMetaKeywords: deleteMetaKeywords,
    setOpenGraph({title, description, image} = {}) {
      let locale =  this.$store.state.locales[this.$store.state.currentLocale]
      locale = (locale && locale.regional && locale && locale.regional.slice(0, 2) || 'uk')
      locale = locale + '_UA'

      if(!title) title = capitalize(this.$tMeta('default-meta-title'))
      if(!description) description = capitalize(this.$tMeta('default-meta-description'))
      if(!image) image = globalConfigs.header.og_image

      setOpenGraphItem('og:locale', locale)
      setOpenGraphItem('og:title', title)
      setOpenGraphItem('og:description', description)
      setOpenGraphItem('og:site_name', 'jobian')
      setOpenGraphItem('og:type', 'website')
      setOpenGraphItem('og:url', window.location.href)
      setOpenGraphItem('og:image', image)
    },

    resetOpenGraphMixin() {
      removeOpenGraphTag('og:locale')
      removeOpenGraphTag('og:title')
      removeOpenGraphTag('og:description')
      removeOpenGraphTag('og:site_name')
      removeOpenGraphTag('og:type')
      removeOpenGraphTag('og:url')
      removeOpenGraphTag('og:image')
    }
  }
}

function getMetaTitle() {
  return document.head.querySelector('title') || createMetaTitle()
}

function createMetaTitle() {
  const tag = document.createElement('title')
  document.head.appendChild(tag)
  return tag
}

function getMetaDescription() {
  return document.head.querySelector('meta[name="description"]') || createMetaDescription()
}

function createMetaDescription() {
  const titleTag = getMetaTitle()
  const tag = document.createElement('meta')
  tag.setAttribute('name', 'description')
  document.head.insertBefore(tag, titleTag.nextSibling || document.head.firstElementChild)

  return tag
}

function getMetaKeywords() {
  return document.head.querySelector('meta[name="keywords"]') || createMetaKeywords()
}

function createMetaKeywords() {
  const tag = document.createElement('meta')
  tag.setAttribute('name', 'keywords')
  document.head.appendChild(tag)
  return tag
}

function deleteMetaKeywords() {
  const tag = document.head.querySelector('meta[name="keywords"]')

  if(tag) {
    tag.parentElement.removeChild(tag)
  }
}

function setOpenGraphItem(property, content) {
  const tag = getOpenGraphTag(property)
  tag.setAttribute('content', content)
}

function getOpenGraphTag(property) {
  return document.head.querySelector(`meta[property="${property}"]`) ||
      createOpenGraphTag(property)
}

function createOpenGraphTag(property) {
  const tag = document.createElement('meta')
  tag.setAttribute('property', property)
  document.head.appendChild(tag)
  return tag
}

function removeOpenGraphTag(property) {
  const tag = document.head.querySelector(`meta[property="${property}"]`)
  if(!tag) return
  document.head.removeChild(tag)
}
